/* global Bugsnag */
import { Component } from "react"
import StripeElementsForm from "components/stripe_elements_form"
import Icon from "components/planning_center_icon"

class AdminPaymentsContainer extends Component {
  constructor(props) {
    super(props)

    this.handleMethodChange = this.handleMethodChange.bind(this)
    this.updateAmount = this.updateAmount.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.handleSelectPerson = this.handleSelectPerson.bind(this)
    this.shouldDisableButton = () => {
      const { paymentMethod, amount, busy, stripeError } = this.state

      return paymentMethod === "" || Number(amount) <= 0 || busy || stripeError.message
    }

    this.state = {
      amount: props.humanizedAmountDue < 0 ? 0 : props.humanizedAmountDue,
      paymentMethod: "",
      note: "",
      checkNumber: "",
      scholarship: false,
      errors: null,
      //notificationIds: [],
      notificationId: "",
      stripeToken: "",
      busy: false,
      stripeError: {}
    }
  }

  render() {
    const {
      paymentOptions,
      event,
      registration,
      stripeAccountId,
      stripeKey,
      stripeEnabled,
      stripeTestmode,
      stripeTestmodeMessageDisabled,
      notificationOptions,
      currency: { symbol, amount_cents }
    } = this.props
    const { amount, paymentMethod, errors, busy } = this.state
    const registrationHref = "/registrations/" + this.props.registration.id

    const disableButton = this.shouldDisableButton()

    return (
      <StripeElementsForm
        registration={registration}
        event={event}
        amountCents={amount_cents}
        stripeAccountId={stripeAccountId}
        stripeKey={stripeKey}
        stripeEnabled={stripeEnabled}
        stripeTestmode={stripeTestmode}
        stripeTestmodeMessageDisabled={stripeTestmodeMessageDisabled}
        hideFields={paymentMethod !== "Credit Card"}
        onChange={stripeError => this.setState({ stripeError })}
        onSuccess={stripeEvent =>
          this.setState({ stripeToken: stripeEvent.token }, this.submitForm)
        }
        onError={stripeError => this.setState({ busy: false, stripeError })}
        render={stripe => (
          <div className="payment-details-modal modal">
            <div className="modal__header">
              <button className="modal__close-button" aria-label="Close modal" data-modal-close="">
                <Icon symbol="general#x" />
              </button>
              <h1 className="modal-title">New Payment</h1>
              <h2 className="modal-subtitle">
                For Registration <a href={registrationHref}>#{registration.id}</a> ({event.name})
              </h2>
            </div>
            <div className="modal__body">
              {errors && (
                <div id="error_explanation" className="error-alert alert">
                  <h3>Uh oh! Looks like there were some problems:</h3>
                  <ul>
                    {errors.map(e => (
                      <li key={e}>{e}</li>
                    ))}
                  </ul>
                </div>
              )}

              <div className="d-f pb-3">
                <div className="pr-1 f-1">
                  <label htmlFor="instrument">Payment method</label>
                  <select
                    name="instrument"
                    id="instrument"
                    className="select"
                    onChange={this.handleMethodChange}
                  >
                    <option value="">Please select</option>
                    {paymentOptions.types.map(t => (
                      <option value={t} key={t}>
                        {t}
                      </option>
                    ))}
                    {paymentOptions.scholarships.length > 0 && (
                      <optgroup label="Scholarships">
                        {paymentOptions.scholarships.map(t => (
                          <option value={t.id} key={t.id}>
                            {t.name} ({t.humanized_remaining})
                          </option>
                        ))}
                      </optgroup>
                    )}
                  </select>
                </div>
                <div className="pl-1 f-1">
                  <label htmlFor="amount">Amount</label>
                  <div className="prepended-label">
                    <span className="label" css={{ height: 30, lineHeight: "1.4" }}>
                      {symbol}
                    </span>
                    <input
                      type="number"
                      name="amount"
                      id="amount"
                      placeholder="Amount"
                      autoComplete="off"
                      value={amount}
                      onChange={e => this.setState({ amount: e.target.value })}
                    />
                  </div>
                </div>
              </div>

              {paymentMethod === "Check" && (
                <div className="pb-3">
                  <label htmlFor="check_number">Check number</label>
                  <input
                    type="text"
                    id="check_number"
                    name="check_number"
                    autoComplete="off"
                    onChange={e => this.setState({ checkNumber: e.target.value })}
                  />
                </div>
              )}

              {(paymentMethod === "Other" || paymentMethod === "Cash") && (
                <div className="pb-3">
                  <label htmlFor="note">Note</label>
                  <input
                    type="text"
                    id="note"
                    name="note"
                    autoComplete="off"
                    onChange={e => this.setState({ note: e.target.value })}
                  />
                </div>
              )}

              {stripe.formFields}

              <label htmlFor="send_receipt_to">Send receipt to:</label>
              <div className="d-f">
                <div className="f-1" key={1}>
                  <select
                    className="select"
                    onChange={this.handleSelectPerson}
                    id="send_receipt_to"
                  >
                    <option value="">No one</option>
                    {notificationOptions.map(person => (
                      <option value={person.id}>
                        {person.first_name + " " + person.last_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="modal__footer d-f jc-fe">
              <button
                className="modal__cancel-button btn2 mr-2"
                aria-label="Cancel new payment"
                data-modal-close=""
              >
                Cancel
              </button>
              <button
                disabled={disableButton}
                className="create-btn btn2 payment-save-button-js"
                onClick={() =>
                  paymentMethod === "Credit Card"
                    ? this.setState({ busy: true }, stripe.createToken())
                    : this.submitForm()
                }
              >
                {busy ? "Please wait" : "Submit"}
              </button>
            </div>
          </div>
        )}
      />
    )
  }

  handleMethodChange(e) {
    const paymentMethod = e.target.value
    let scholarship = false

    if (Number(paymentMethod)) {
      scholarship = true
    }

    this.setState({ paymentMethod, scholarship }, this.updateAmount)
  }

  updateAmount() {
    const { paymentOptions } = this.props
    const { paymentMethod, scholarship, amount } = this.state
    let updatedAmount = amount

    if (scholarship) {
      const chosenScholarship = paymentOptions.scholarships.find(
        o => o.id === Number(paymentMethod)
      )
      const remaining = chosenScholarship.total_remaining_cents / 100
      updatedAmount > remaining ? (updatedAmount = remaining) : updatedAmount
    }
    this.setState({ amount: updatedAmount < 0 ? 0 : updatedAmount })
  }

  handleSelectPerson({ target: { value } }) {
    this.setState({ notificationId: value })
  }

  submitForm() {
    const { idempotencyKey, registration } = this.props
    const {
      amount,
      scholarship,
      paymentMethod,
      stripeToken,
      checkNumber,
      note,
      notificationId
    } = this.state

    this.setState({ busy: true })

    fetch(`/registrations/${registration.id}/payments.json`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": $.rails.csrfToken()
      },
      credentials: "include",
      body: new Blob([
        JSON.stringify({
          payment: {
            scholarship_id: scholarship ? paymentMethod : "",
            idempotency_key: idempotencyKey,
            instrument: scholarship ? "Scholarship" : paymentMethod,
            check_number: checkNumber,
            person_ids_to_notify: [notificationId],
            stripe_token: stripeToken.id,
            note,
            amount
          }
        })
      ])
    })
      .then(resp => resp.json())
      .then(resp => {
        if (resp.errors) {
          this.setState({ busy: false, errors: resp.errors })
        } else {
          Turbolinks.visit(`/registrations/${registration.id}`)
        }
      })
      .catch(resp => Bugsnag.notifyException(resp, "PaymentSubmitError"))
  }
}

export default AdminPaymentsContainer
